import { api } from '../../lib/api'

export type AmbassadorTierRate = {
  tier_level: number
  l1_bps: number
  l2_bps: number
  l3_bps: number
}

export type AmbassadorResponse = {
  me: { id: string; handle: string; display_name: string }
  referral: { code: string; url: string; qr_url: string | null }
  status: {
    tier: string
    tier_level: number
    is_eligible: boolean
    ineligible_reason: string | null
    reputation_score: number
    activity_last_30d: boolean
    eligibility_checks?: Array<{ label: string; ok: boolean; detail?: string }>
    next_tier: null | {
      tier: string
      requirements: { reputation_score: number; active_last_30d: boolean }
    }
  }
  rates: {
    protocol_fee_bps: number
    explainer?: { protocol_fee_bps: number; rates_apply_to: 'protocol_fee' | string }
    tiers: AmbassadorTierRate[]
  }
  summary: {
    earned_month: string
    earned_lifetime: string
    pending?: string
    active_referrals: number
  }
  recent_activity: Array<{
    id: string
    created_at: string
    amount: string
    status: 'pending' | 'settled' | string
    note: string
    source?: string
  }>
}

export async function getAmbassadorEarnings(): Promise<AmbassadorResponse> {
  const { data } = await api.get<AmbassadorResponse>('/api/earnings/ambassador/')
  return data
}
